import { ApiResponse, User } from '@api';

export const getUsers: ApiResponse<User[]> = {
  ok: true,
  data: [
    {
      id: '08dd63ca-a100-41cc-8798-214b76dd5e5d',
      username: 'Mrv7',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd6229-e710-4aec-8ccc-939bf7ca07b7',
      username: 'Sonali_ck',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd5cf3-4593-4a54-894c-f07c2ffc0c01',
      username: 'BigBoss1212',
      bio: null,
      profilePictureUrl:
        'https://avatars.slack-edge.com/2025-03-06/8586571315584_eadf1f21e53d24ed4cc3_192.png',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd57d5-e980-4f55-84e8-de996e135b5b',
      username: 'tzahibena',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd5697-ee53-42ed-86bc-d0c373912352',
      username: 'James',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd564c-4f0e-4549-8772-d3514c7b762f',
      username: 'careypydev',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd5436-b140-4d2e-88b1-eb894f8e3432',
      username: 'Gabriel',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd4ea2-888a-421f-8691-7d6202264573',
      username: 'surajb0710',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd42ed-03e4-4ba9-8dd8-5153436266fa',
      username: 'archit_sharma',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd422e-90f3-405f-8df3-8826c3d2b27c',
      username: 'unicorn798',
      bio: null,
      profilePictureUrl:
        'https://avatars.slack-edge.com/2025-01-31/8395557427105_fb09cd9340abbf19c673_192.jpg',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd415f-b05e-4d88-8952-4c661e9c9871',
      username: 'tbeck1123',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd3eef-d4f0-4567-89ec-abe8405414ec',
      username: 't',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd3eef-567a-477b-8397-5e16d41420c3',
      username: 'test',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd39a0-77a3-4df5-8bb0-7cb129cb451a',
      username: 'unicorn797',
      bio: null,
      profilePictureUrl:
        'https://avatars.slack-edge.com/2025-01-20/8322622771858_4ba5d9ed7be0cf06f6d6_192.png',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd35a8-ff69-40c3-8da5-2d7988db2350',
      username: 'Mykolanovikov',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd309d-8c1e-45e9-8c45-7f61d4bf1d51',
      username: 'Heather85',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd2fd3-d20f-442d-874d-3def293a8097',
      username: 'rufai_t',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd2f60-b4b2-4723-826d-80d92a9f84cc',
      username: 'unicorn796',
      bio: null,
      profilePictureUrl:
        'https://secure.gravatar.com/avatar/c3ca97e0acdfb74b0cb539e6f5c9911f.jpg?s=192&d=https%3A%2F%2Fa.slack-edge.com%2Fdf10d%2Fimg%2Favatars%2Fava_0006-192.png',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd2a74-ba9c-4bf4-872e-ca211f421a5d',
      username: 'Mard',
      bio: null,
      profilePictureUrl: '',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
    {
      id: '08dd2963-6451-4a22-8583-70e7da6fa6e8',
      username: 'unicorn795',
      bio: null,
      profilePictureUrl:
        'https://avatars.slack-edge.com/2024-12-30/8257375733088_9ef4ffb734e9950f6785_192.png',
      lookingForProject: true,
      gitHubUsername: '',
      technologies: [],
    },
  ],
};
